import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import {
  NewWarningIcon,
  RecognitionCloseIcon,
} from "../../utils/icons";
import { ColumnCenter, ColumnLeft, ColumnRight, TableData, TableHeader,StyledModal,StyledTitle,StyledBody } from "./styles";
import { commaSeperator, getInitials } from "../../utils/methods";
import { Border } from "../RecogntionAdmin/styles";

class HealthRiskPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  showDetailInitiative = () => {
    const { healthData } = this.props;
    const costData = [
      {
        label: 'Year 1',
        cost: healthData.healthCostYear1,
      },
      {
        label: 'Year 3',
        cost: healthData.healthCostYear3,
      },
    ];
    return (
      <React.Fragment>
        <TableHeader>
          <ColumnLeft>Cost Per Person</ColumnLeft>
          <ColumnCenter>People</ColumnCenter>
          <ColumnRight>Total Health Costs</ColumnRight>
        </TableHeader>
       
        {costData.map(({ label, cost }) => (
          <TableData key={label}>
            <ColumnLeft>{label}: ${commaSeperator(Math.trunc(cost))}</ColumnLeft>
            <ColumnCenter>{healthData.people}</ColumnCenter>
            <ColumnRight>${Math.floor(cost * healthData.people).toLocaleString()}</ColumnRight>
          </TableData>
        ))}

      </React.Fragment>
    );
  };

  render() {
    const { showModal, onClose, healthData } = this.props;
    return (
      <StyledModal
        transform={1}
        show={showModal}
        newWidth={"600px"}
        newBg={"newBg"}
        // height="50px"
        display="none"
        // width={"800px"} height={"492px"}
      >
        <Modal.Header
          closeButton
          onHide={() => onClose()}
          style={{ background: "white" }}
        >
          <StyledTitle><span style={{marginRight:"16px"}}>{NewWarningIcon("#B1AA56")}</span> {healthData.cardName} </StyledTitle>
          <div
            onClick={() => onClose()}
            style={{ cursor: "pointer" }}
          >
            {RecognitionCloseIcon()}
          </div>
        </Modal.Header>

        <StyledBody style={{padding: "24px 24px 16px 24px"}}>
          <div className="body">
            <div className="icon"                       
              style={{
                backgroundColor: healthData?.background_color,
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color:"white"
              }}>{this.props.isTopRisks ? healthData.icon : getInitials(healthData.name)} </div>
            <div className="desc">A high {healthData.name} of over 30 is impacting {healthData.people} people in your
            organization. </div>

          </div>
          <Border margin="20px 0px 0px 0px"/>
          {/* <DetailInitiativeWrapper background={healthData?.color?healthData?.color:"#005c87"}> */}
          {this.showDetailInitiative()}
          {/* </DetailInitiativeWrapper> */}
        </StyledBody>
      </StyledModal>
    );
  }
}

HealthRiskPopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  history: PropTypes.object,
  healthData: PropTypes.array,
  isTopRisks:PropTypes.string
};

export default (HealthRiskPopup);
